var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    [
      _c(
        "div",
        { staticClass: "wappen" },
        [
          _c("Wappen", { attrs: { corps: "aktive" } }),
          _c("Wappen", { attrs: { corps: "piccolos" } }),
          _c("Wappen", { attrs: { corps: "reservisten" } }),
          _c("Wappen", { attrs: { corps: "eos" } }),
        ],
        1
      ),
      _c(
        "router-link",
        { attrs: { to: "/" } },
        [
          _c("Headline", { attrs: { level: 1, styling: "site-title" } }, [
            _vm._v("Ehrengarde der Stadt Neuwied e.V."),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }